export const MENUS_REQUEST_ACTONS_MAPPING = {
  lsPendingQuote: 'pendingQuote',
  lsConfirmQuote: 'confirmQuote',
  lsMaking: 'making',
  lsReviewQuote: 'reviewQuote',
  lsSettled: 'settled',
  lsMyAdvance: 'myAdvance',
};
